import { z } from 'zod'

import { pagedSchema } from '../core'

const text = z.string().nullish()

/**
 * Who from one account is on one project. A project has at most one mapping per account; the people of that account who work on
 * the project are `assignedUserIds`.
 */
export const projectMappingSchema = z.object({
  id: z.string(),
  projectId: z.string(),
  projectName: text,
  assignedAccountId: z.string(),
  assignedAccountName: text,
  assignedUserIds: z.array(z.string()).nullish(),
  createdBy: z.string(),
  createdAt: z.string(),
  updatedAt: text,
})
export type ProjectMappingDto = z.infer<typeof projectMappingSchema>

export const projectMappingPageSchema = pagedSchema(projectMappingSchema)

/** POST /api/v1/project-mappings. At least one user and at most 500. */
export interface ProjectMappingCreateBody {
  assignedAccountId: string
  assignedUserIds: string[]
  projectId: string
  createdBy: string
}

/** PUT /api/v1/project-mappings/{id}: replaces the people (at least one; remove the mapping itself to take everyone off). */
export interface ProjectMappingUpdateBody {
  assignedAccountId: string
  assignedUserIds: string[]
}

export interface ProjectMappingFilters {
  projectId?: string
  assignedAccountId?: string
  /** Mappings this user is in. */
  userId?: string
}
